<template>
  <div class="passwordetail">
    <navBack title="会员证书"></navBack>
    <div class="passwordetail_title">
      <p>会员证书</p>
    </div>
    <div class="passwordetail_body">
      <div class="passwordetail_body__content">
        <p @click="downs">下载证书</p>
        <el-image :src="url" class="imgVlist" :preview-src-list="srcList">
        </el-image>
      </div>
    </div>
    <canvas
      id="mycanvas"
      width="750"
      height="530"
      style="display: none"
      class="my-canvas"
    ></canvas>
  </div>
</template>

<script>
import navBack from "../../components/navBack.vue";
import { getVipUser } from "../../api/moudles/user.js";
export default {
  data() {
    return {
      url: require("../../assets/img/userIndex/cartic.png"),
      srcList: [],
    };
  },
  components: {
    navBack,
  },
  created() {
    this.getVipUser();
  },
  methods: {
    // 不同源图片下载
    downloadImage(imageSrc, name) {
      //下载地址和名称
      var image = new Image();
      // 解决跨域Canvas污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); //生成一个a元素
        var event = new MouseEvent("click"); //创建一个点击事件
        a.download = name || "photo"; //设置图片名称
        a.href = url; //将生成的url设置为a.href属性
        a.dispatchEvent(event); //触发a的单击事件
      };
      image.src = imageSrc;
    },
    // 文件下载
    downs() {
      this.downloadImage(this.url, "会员证书");
    },
    // 获取用户信息
    async getVipUser() {
      await getVipUser({
        success: (res) => {
          this.drawPhoto(res.data);
        },
      });
    },
    drawPhoto(data) {
      let canvas = document.getElementById("mycanvas"); //创建canvas
      let context = canvas.getContext("2d"); //创建画布
      let img = new Image(); //因为拿不到图片静态资源，所以创建图片标签
      img.setAttribute("crossOrigin", "anonymous"); //解决图片跨域问题,也要放到赋值前，否ze大部分浏览器会报错
      img.src = require("../../assets/img/userIndex/cartic.png");
      //加载图片
      img.onload = () => {
        canvas.setAttribute("width", img.width);
        canvas.setAttribute("height", img.height);
        //绘制图片
        context.drawImage(img, 0, 0, img.width, img.height);
        //字体大小
        context.font = "bold 40px 微软雅黑";
        //字体文字，显示位置  图片上需要n个文字就写n个context.fillText(文字,上下,左右);
        context.fillText(data.realName + "：", 150, 600);

        context.font = "32px 微软雅黑";
        context.fillText("根据本会章程，经审核，同意接收你为", 230, 660);
        context.fillText("本会个人会员。", 150, 720);

        context.font = "28px 微软雅黑";
        context.fillText("会员编号：" + (data.memberCode || ""), 230, 1000);
        context.fillText("发证日期：" + (data.effectiveDate || ""), 230, 1050);
        context.fillText(
          "有效期至：" + (data.effectiveDateTo || ""),
          230,
          1100
        );
        context.fillText("服务主体：" + data.serviceMainLabel, 230, 1150);
        //合成图片
        this.url = canvas.toDataURL("image/jpg", 1.0);
        this.$set(this.srcList, [0], canvas.toDataURL("image/jpg", 1.0));
      };
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .passwordetail_title {
    display: none;
  }

  .imgVlist {
    width: 100%;
    height: auto;
  }
}

@media screen and (min-width: 750px) {
  .passwordetail_title {
    height: 60px;
    font-weight: 500;
    font-size: 22px;
    line-height: 60px;
    padding-left: 20px;
    border-bottom: 1px solid #f2f2f2;
  }

  .imgVlist {
    width: 400px;
    height: auto;
  }
}

.passwordetail_body__content {
  margin: 20px 0;
  padding: 20px;
  display: flex;
  flex-flow: column;
  align-items: flex-end;
}

.passwordetail {
  min-height: 650px;
  background-color: #fff;
}

.passwordetail_body {
  min-height: 600px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.passwordetail_body__content p {
  display: inline-block;
  height: 40px;
  margin-bottom: 20px;
  width: 90px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
  background-color: #c22c25;
  color: #fff;
}
</style>
